import React from 'react';
import { Eyebrow } from './Eyebrow';
import { useBrand } from '../../contexts/BrandContext';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  tone?: 'ink' | 'cream';
  align?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'ink',
  align = 'left',
  className = '',
  children
}: SectionHeadingProps) {
  const isCream = tone === 'cream';
  const {
    text
  } = useBrand();
  return <div className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : ''} ${className}`} data-id="element-379" data-mp="i6wysfexouu5">
      {eyebrow && <Eyebrow className="text-brick" data-id="element-380" data-mp="d9el6bpz1rft">{eyebrow}</Eyebrow>}
      <h2 className={`mt-4 font-serif text-4xl leading-[1.08] md:text-[3.25rem] ${isCream ? 'text-ink-deep' : 'text-ink'}`} data-id="element-381" data-mp="8aaebrqis5sn">
        {text(title)}
      </h2>
      {intro && <p className={`mt-5 max-w-xl text-base leading-relaxed ${align === 'center' ? 'mx-auto' : ''} text-ink-soft`} data-id="element-382" data-mp="3ve84kl1xeigc">
          {text(intro)}
        </p>}
      {children}
    </div>;
}